import React from 'react';

/** @param {{ children: React.ReactNode, tone?: 'neutral'|'ok'|'warn'|'danger'|'info' }} props */
export default function AdminStatusBadge({ children, tone = 'neutral' }) {
  return <span className={`admin-hub-kit-badge admin-hub-kit-badge--${tone}`}>{children}</span>;
}
